import { ApiVersions } from '@gonfalon/openapi/api-versions';
import { useQuery } from '@tanstack/react-query';

import type { AggregationType, Granularity, UsageTabKey } from '../../types';
import { usageTabConfig } from '../constants/usageTabConfig';
import { getSeriesTotal } from '../utils/getSeriesTotal';
import { resolveQueryFn } from '../utils/resolveQueryFn';

type UseUsageDataProps = {
  usageTab: UsageTabKey;
  aggregationType: AggregationType;
  from: number;
  to: number;
  granularity: Granularity;
};

export function useUsageData({ usageTab, from, to, aggregationType, granularity }: UseUsageDataProps) {
  const { queryFnName } = usageTabConfig[usageTab];
  const queryFn = resolveQueryFn(queryFnName);
  const queryOptions = queryFn({
    apiVersion: ApiVersions.Beta,
    query: {
      aggregationType,
      from: from.toString(),
      to: to.toString(),
      granularity,
    },
  });

  const query = useQuery(queryOptions);
  const total = getSeriesTotal({ series: query.data?.series ?? [], aggregationType, granularity });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    total,
  };
}
